module.exports = __webpack_public_path__ + "static/media/UploadImage.81594caa.png";